import React from "react";

const NeccLogisticsInner = () => {
  return (
    <>
      {/* Start Services area  */}
      <div className='service-area pd-top-45 pd-bottom-45 '>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-11 align-self-center'>
                <div className='about-inner-wrap'>
                  <div className='section-title mb-0'>
                  <span className='subtitles'>NECC LOGISTICS</span>
                <h2 className='title'>A Dependable Logistics Partner</h2>
             
                  <p className='content'>
                  Our yet another specialized division ‘NECC Logistics’, is a niche 3PL and warehousing solution provider in India. Completely updated, augmented and expanded, we provide fast and convenient services and also address specific logistics issues and needs.
                    </p>
          
                <p className='content'>
                We offer Single Window Solution for complete third party logistics (3PL) including warehousing, distribution and transportation management. This helps us manage all inventory processes and billing smoothly.
                </p>
                <p className='content'>
                Apart from that, we also offer value added services like order fulfillment, re-packaging, reverse logistics, dedicated contract logistics, supply chain network analysis & design, and consultancy to our valued clients.
                </p>
          <h4 style={{marginTop:"20px",marginBottom:"20px"}}>Highlights of our Exclusive Logistics Services</h4>
                <div className='row'>
                      <div className='col-xl-6 col-lg-12 col-md-6'>
                        <ul className='list-inner-wrap mb-mb-0 mb-3 mb-lg-3 mb-xl-0'>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />{" "}
                           Warehousing and services
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Logistics services and solutions
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            3PL, inbound, outbound logistics
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Distribution and freight management
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Consolidation and deconsolidation
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            IT and logistics technology for SCM
                          </li>
                        </ul>
                      </div>
                    </div>
                 </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      {/* End Services area  */}
    </>
  );
};

export default NeccLogisticsInner;
